import React from 'react';
import './Experience.css';
import {useContext} from 'react';
import {themeContext} from '../../Contest';

function Experience() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode
  return (
    <div className='experience' id='Experience'>
        <div className="achievement">
          <div className="circle" style={{color: darkMode? 'black':'black'}}>2+</div>
          <span>years</span>
          <span>Experience</span>
        </div>

        <div className="achievement">
          <div className="circle" style={{color: darkMode? 'black':'black'}}>5+</div>
          <span>completed</span>
          <span>projects</span>
        </div>

        {/* <div className="achievement">
          <div className="circle">5+</div>
          <span>Companies</span>
          <span>Work</span>
        </div> */}
    </div>
  )
}

export default Experience
